import React, { useEffect, useState } from "react";
import RdbmsTemplateEditor from "./RdbmsTemplateEditor";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useTemplateContext } from "../../../context/TemplateContext";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";

const RdbmsTemplateViewer = ({ file }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [dbConnectors, setDbConnectors] = useState([]);
  const { setFieldsArr, setTemplateData, templateData } = useTemplateContext();

  const processData = (parentData, data) => {
    const { table_name, fields, sql_query, database_type, is_group, is_group_mapping, db_connector } = data;

    let obj = {};

    switch (parentData) {
      case "rdbms":
        obj = {};
        obj["table_name"] = table_name;
        obj["is_group"] = is_group;
        obj["is_group_mapping"] = is_group_mapping;
        obj["fields"] = fields === "null" ? [] : fields;
        obj["sql_query"] = sql_query;
        obj["database_type"] = database_type;
        obj["db_connector"] = db_connector ? db_connector : "";
        setFieldsArr(fields);
        break;
      case "postgres":
        obj = {};
        obj["table_name"] = table_name;
        obj["fields"] = fields === "null" ? [] : fields;
        obj["sql_query"] = sql_query;
        setFieldsArr(fields);
        break;
      default:
        break;
    }
    return obj;
  };

  const fetchSingleTemplate = async (parentData, id) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/${parentData}/${id}`);
      const { data } = response;

      const config = processData(parentData, data);
      setTemplateData(config);
    } catch (error) {
      handleApiError(error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDbConnectors = async () => {
    try {
      const { data } = await axiosInstance.get("/dbconnector");
      setDbConnectors(data);
    } catch (error) {
      handleApiError(error);
      setError(error.message);
    }
  };

  useEffect(() => {
    if (file.id) {
      fetchSingleTemplate(file.parentData, file.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  useEffect(() => {
    fetchDbConnectors();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!templateData) return null;

  return (
    <RdbmsTemplateEditor
      file={file}
      templateData={templateData}
      setTemplateData={setTemplateData}
      dbConnectors={dbConnectors}
    />
  );
};

export default RdbmsTemplateViewer;
